import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { ResponseType } from "src/utils/enums";

@Component({
  selector: 'app-survey-button-multi-group',
  templateUrl: './survey-button-multi-group.component.html',
  styleUrls: ["./survey-button-multi-group.component.scss"],
  standalone: false
})
export class SurveyButtonMultiGroupComponent implements OnChanges, OnInit {
  @Input() questionDetails: any;
  @Input() surveyData: any;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  questionAnswerMap: any = {};
  constructor() {
    console.log("Survey button multi group component loaded.");
   }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.questionAnswerMap = this.questionDetails.SelectedAnswer?.Answers || {};
    for (let q of this.questionDetails.Questions) {
      if (this.questionAnswerMap[q.QuestionId]) {
        q.SelectedAnswer = this.questionAnswerMap[q.QuestionId][0];
      }
    }
  }

  answerSelected(answer: any): void {
    this.questionAnswerMap = this.questionDetails.SelectedAnswer?.Answers || {};
    this.questionAnswerMap[answer.QuestionId] = [answer];
    this.answerSelectedEvent.emit(this.convertToSurveyAnswer());
  }

  convertToSurveyAnswer(): any {
    const surveyAnswer: any = {
      Answers: this.questionAnswerMap,
      Action: this.questionDetails.Action,
      ResponseType: ResponseType.MultiQuestionMultiGroup,
      AnswerTime: new Date().toISOString()
    };

    this.questionDetails.SelectedAnswer = surveyAnswer;

    return surveyAnswer;
  }
}
